import { baseApi, transformErrorResponse } from '@ibk/shared-config';
export const accountsPayableApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAccountsPayable: builder.query({
            query: params => ({
                url: '/v1/account-payables/payments',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
                params,
                priority: 'high',
            }),
        }),
        deleteAccountsPayable: builder.mutation({
            query: ({ id }) => ({
                url: `/v1/account-payables/payments/${id}/cancel`,
                method: 'POST',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
    }),
});
export const { useLazyGetAccountsPayableQuery, useDeleteAccountsPayableMutation } = accountsPayableApi;
